export function convertTo12HourFormat(time24: string): {
  time: string;
  period: "AM" | "PM";
} {
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  if (!timeRegex.test(time24)) {
    throw new Error('Invalid time format. Use 24-hour format like "15:30"');
  }

  const [hourStr, minuteStr] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const minutes = minuteStr;

  let period: "AM" | "PM" = "AM";

  if (hour === 0) {
    hour = 12;
  } else if (hour === 12) {
    period = "PM";
  } else if (hour > 12) {
    period = "PM";
    hour -= 12;
  }

  const formattedHour = hour.toString().padStart(2, "0");
  const formattedTime = `${formattedHour}:${minutes}`;

  return { time: formattedTime, period };
}

export function calculateTimeDifference(
  startTime: string,
  endTime: string
): string {
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
  if (!timeRegex.test(startTime) && !timeRegex.test(endTime)) {
    console.log(
      'Invalid time format. Use 24-hour format like "15:30". Empty string is returned for time'
    );
    return "-";
  } else if (startTime && !endTime) {
    return startTime;
  } else if (endTime && !startTime) {
    return endTime;
  }

  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);
  const startTotalMinutes = startHours * 60 + startMinutes;
  const endTotalMinutes = endHours * 60 + endMinutes;
  let diffMinutes = endTotalMinutes - startTotalMinutes;

  if (diffMinutes < 0) {
    diffMinutes += 24 * 60;
  }

  return diffMinutes === 1 ? "1 min" : `${diffMinutes} mins`;
}
